import { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { getNotifications } from '../api/notificationsApi';

// A bell icon with a small red dot badge if there are unread notifications.
// Fetches the unread count on mount — used in the header on Loads, Payments, Profile.
function NotificationBadge({ onClick }) {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    async function fetchCount() {
      try {
        const result = await getNotifications();
        if (result.success) {
          setUnreadCount(result.unread_count);
        }
      } catch (err) {
        // Silently fail here — a badge not loading shouldn't disrupt the whole screen.
      }
    }

    fetchCount();
  }, []);

  return (
    <button onClick={onClick} style={styles.button}>
      <Bell size={20} color="#374151" />
      {unreadCount > 0 && <span style={styles.dot} />}
    </button>
  );
}

const styles = {
  button: {
    position: 'relative',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 6,
  },
  dot: {
    position: 'absolute',
    top: 4,
    right: 4,
    width: 9,
    height: 9,
    borderRadius: '50%',
    backgroundColor: '#dc2626',
    border: '1.5px solid white',
  },
};

export default NotificationBadge;